import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getCardDetails = async () => {
  try {
    //   return await get<ApiResponse<[]>>(`/stripepayments/cards?stripe_customer_id=${customerId}`).then((res)=> {
    return await get<ApiResponse<[]>>(
      `/stripepayments/cards`,
    ).then((res) => {
      if (res?.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e) {
    HandleApiError(e);
  }
};
